import { apiEndpoint } from "../utils/env";

async function fetchWithAuth(url, token, options = {}) {
  const headers = options.headers ? { ...options.headers } : {};
  if (token) headers["Authorization"] = `Bearer ${token}`;
  headers["Content-Type"] = headers["Content-Type"] || "application/json";
  const res = await fetch(url, { ...options, headers });
  const txt = await res.text();
  let json = null;
  try {
    json = txt ? JSON.parse(txt) : null;
  } catch {
    json = txt;
  }
  if (!res.ok) {
    const errMsg =
      json && json.message
        ? json.message
        : typeof json === "string"
        ? json
        : res.statusText;
    const error = new Error(errMsg || `Request failed: ${res.status}`);
    error.status = res.status;
    error.details = json;
    throw error;
  }
  return json;
}

export async function getMyNotifications(token) {
  const url = apiEndpoint("/api/Notifications");
  return fetchWithAuth(url, token, { method: "GET" });
}

export async function getNotificationHistory(token) {
  const url = apiEndpoint("/api/Notifications/history");
  return fetchWithAuth(url, token, { method: "GET" });
}

export async function markNotificationRead(token, id) {
  const url = apiEndpoint(`/api/Notifications/${id}/read`);
  return fetchWithAuth(url, token, { method: "POST" });
}

export async function dismissNotification(token, id) {
  const url = apiEndpoint(`/api/Notifications/${id}/dismiss`);
  return fetchWithAuth(url, token, { method: "POST" });
}
